<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ  OR-202203000001</b></div>
            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #fdac39">กำลังดำเนินการ</b></div>
            <!--              <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">เสร็จสิ้น</b></div>-->
            <!--              <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #eb5c5d">ยกเลิก</b></div>-->
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">สุธิชา องค์วงศ์สกุล</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div class="ml-1 mr-3">481/18 ต.หนองหาร อ.สันทราย จ.เชียงใหม่ 50290</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div class="ml-1 mr-3">0882677224</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div class="ml-1 mr-3">โอนเงิน</div>
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <div class="ml-1 mr-3">629.00 บาท</div>
                </div>
                <div class="mt-2 display_pc">
                  <v-btn elevation="5" @click="image_modal = true" class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                </div>
              </div>
              <div class="mx-auto">
                <v-img class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                <!--                <v-img class="rounded" height="120" width="120" max-width="120" :lazy-src="picture_holder" :src="data.img"></v-img>-->
              </div>
              <div class="mt-2 display_mobile">
                <v-btn elevation="5" @click="image_modal = true" class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" height="120" width="120" max-width="120" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div v-if="dataDetail.item.product_count !== null"><b>{{ dataDetail.item.product_name }}</b> ({{ dataDetail.item.product_count }})</div>
                      <div v-else><b>{{ dataDetail.item.product_name }}</b></div>
                      <div v-if="dataDetail.item.product_list !== null" >
                        <div v-for="(count, index) in dataDetail.item.product_list" :key="index">
                          <div>{{ count.name }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ dataDetail.item.price_per_unit }}</td>
                    <td class="border_table text-center">{{ dataDetail.item.quantity }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ dataDetail.item.total_price }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td class="border_table text-center"><b>80.00</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td class="border_table text-center"><b>629.00</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : 629.00 บาท </div>
                </div>
                <div class="pa-6">
                  <v-img class="mx-auto" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail" class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct" class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_identify",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      perPage: -1,
      image_modal: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [
        {
          id: 1,
          product_name: 'Fisherman\'s Friend ฟิชเชอร์แมน เฟรนด์  (25 ก.) คละรส',
          product_count: 'ชุดคละ 12 ชิ้น',
          product_list: [
            {name: 'Fisherman\'s Friend มิกซ์เบอรี่ x1'},
            {name: 'Fisherman\'s Friend เชอรี่ x1'},
            {name: 'Fisherman\'s Friend แบล็คเคอร์แรนท์ x1'},
            {name: 'Fisherman\'s Friend แมนดาริน x1'},
            {name: 'Fisherman\'s Friend ซิตรัส x1'},
            {name: 'Fisherman\'s Friend น้ำผึ้งผสมมะนาว x1'},
            {name: 'Fisherman\'s Friend มิ้นท์ x6 '},
          ],
          price_per_unit: '200.00',
          quantity: '2',
          unit_name: 'ชุด',
          total_price: '200.00',
        },
        {
          id: 2,
          product_name: 'ชุดทำแผล',
          product_count: null,
          product_list: [
            {name: 'เบตาดีน 1 ขวด'},
            {name: 'น้ำเกลือ 1 ขวด'},
            {name: 'ผ้าก๊อซ 1 แพ็ค'},
          ],
          price_per_unit: '160.00',
          quantity: '1',
          unit_name: 'ชุด',
          total_price: '160.00',
        },
        {
          id: 3,
          product_name: 'ชุดทำแผล',
          product_count: null,
          product_list: null,
          price_per_unit: '189.00',
          quantity: '1',
          unit_name: 'กล่อง',
          total_price: '189.00',
        },
      ],
    }
  },
  methods: {
    confirm_detail() {
      const id = 1
      this.$router.push('/sell/confirmcustomerdetail/' + id)
    },
    in_correct() {
      const id = 1
      this.$router.push('/sell/paycustomerincorrect/' + id)
    }
  },
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.mobile_btn {
  width: 50%;
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_btn {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
}
</style>
